import { computed, onMounted, onUpdated } from 'vue'
import supportTypeEnum from './supportTypeEnum'
import { useStore } from 'vuex'
import donationTypeValidator from './validators/donationTypeValidator'
import teamValidator from './validators/teamValidator'
import deltagerValidator from './validators/deltagerValidator'

export default {
    name: 'SupportSelector',
    props: {
        stafetId: {
            type: String,
            required: true
        },
        labels: {
            type: Object,
            required: true
        },
        displayInputError: {
            type: Boolean,
            required: false,
            default: false
        },
        onChangeCallback: {
            type: Function,
            required: true
        },
        holdList: {
            type: Array,
            required: false,
            default: []
        }
    },
    setup(props) {
        const store = useStore()

        const donationFor = computed(() => {
            return store.state.donation.donationFor
        })

        const donationTeam = computed(() => {
            return store.state.donation.donationTeam
        })

        const donationParticipant = computed(() => {
            return store.state.donation.donationParticipant
        })

        const teams = computed(() => {
            const result = []
            if (props.holdList.length > 0) {
                props.holdList.forEach((hold) =>
                    result.push({
                        name: hold.name,
                        value: hold.holdKode,
                        selected: hold.holdKode === donationTeam.value
                    })
                )
            } else {
                const teams = store.state.donation.teams
                teams.map((team) => {
                    result.push({
                        name: team.name,
                        value: team.id,
                        selected: team.id === donationTeam.value
                    })
                })
            }
            return result
        })

        const participants = computed(() => {
            const result = []
            const participants = store.state.donation.participants
            participants.map((participant) => {
                result.push({
                    selected: participant.id === donationParticipant.value,
                    name: `${participant.firstName} ${participant.lastName ?? ''}`,
                    value: participant.id
                })
            })
            return result
        })

        const isTeamSelected = computed(() => {
            const isTeam = donationFor.value === supportTypeEnum.TEAM

            if (isTeam) {
                store.dispatch('donation/participants')
            }

            return isTeam
        })

        const isDeltagerSelected = computed(() => {
            const isDeltager = donationFor.value === supportTypeEnum.DELTAGER

            if (isDeltager) {
                store.dispatch('donation/participants')
            }
            return isDeltager
        })

        const isSupportTypeValid = computed(() => {
            return donationTypeValidator()
        })

        const isTeamValid = computed(() => {
            let isTeamValid = donationTeam.value !== ''
            store.dispatch('donation/participants', {
                teamId: isTeamValid ? donationTeam.value : undefined
            })

            return teamValidator()
        })

        const isDeltagerValid = computed(() => {
            return deltagerValidator()
        })

        const supportTypeHandler = (e) => {
            store.dispatch('donation/donationFor', {
                donationFor: e.target.value
            })
        }

        const teamHandler = (e) => {
            store.dispatch('donation/participants')
            store.dispatch('donation/donationParticipant', {
                participant: ''
            })
            store.dispatch('donation/donationTeam', { team: e.target.value })
        }

        const participantHandler = (e) => {
            store.dispatch('donation/donationParticipant', {
                participant: e.target.value
            })
        }

        const supportSelectorConfig = computed(() => [
            {
                id: 'support-selector',
                label: props.labels.yourSupportSelectorDropdownLabel,
                shown: true,
                required: true,
                isValid: isSupportTypeValid.value,
                errorMessage:
                    props.labels.yourSupportSelectorDropdownErrorMessage,
                handler: supportTypeHandler,
                defaultOption: {
                    name: props.labels.yourSupportSelectorDropdownPlaceholder,
                    value: supportTypeEnum.NONE
                },
                options: [
                    {
                        name: props.labels
                            .yourSupportSelectorDropdownOptionStafet,
                        value: supportTypeEnum.STAFET,
                        selected: supportTypeEnum.STAFET === donationFor.value
                    },
                    {
                        name: props.labels
                            .yourSupportSelectorDropdownOptionHold,
                        value: supportTypeEnum.TEAM,
                        selected: supportTypeEnum.TEAM === donationFor.value
                    },
                    {
                        name: props.labels
                            .yourSupportSelectorDropdownOptionDeltager,
                        value: supportTypeEnum.DELTAGER,
                        selected: supportTypeEnum.DELTAGER === donationFor.value
                    }
                ]
            },
            {
                id: 'team-selector',
                label: props.labels.yourSupportSelectorDropdownHoldLabel,
                shown: isTeamSelected.value || isDeltagerSelected.value,
                required: true,
                isValid: isTeamValid.value,
                errorMessage:
                    props.labels.yourSupportSelectorDropdownHoldErrorMessage,
                handler: teamHandler,
                defaultOption: {
                    name: props.labels
                        .yourSupportSelectorDropdownHoldPlaceholder,
                    value: ''
                },
                options: teams.value
            },
            {
                id: 'participant-selector',
                label: props.labels.yourSupportSelectorDropdownDeltagerLabel,
                shown: isDeltagerSelected.value,
                required: true,
                isValid: isDeltagerValid.value,
                errorMessage:
                    props.labels
                        .yourSupportSelectorDropdownDeltagerErrorMessage,
                handler: participantHandler,
                defaultOption: {
                    name: props.labels
                        .yourSupportSelectorDropdownDeltagerPlaceholder,
                    value: ''
                },
                options: participants.value
            }
        ])

        const handleChangeCallback = () => {
            if (props.onChangeCallback) {
                props.onChangeCallback({
                    donationFor: donationFor.value,
                    donationTeam: donationTeam.value,
                    donationParticipant: donationParticipant.value,
                    isValid: isSupportTypeValid.value && isTeamValid.value && isDeltagerValid.value
                })
            }
        }

        onMounted(() => {
            handleChangeCallback()
        })

        onUpdated(() => {
            handleChangeCallback()
        })

        return {
            supportSelectorConfig,
            donationFor,
            donationTeam,
            donationParticipant
        }
    }
}
